import { FC } from 'react';
import styled, { css } from 'styled-components';

const FilterOption: FC<any> = ({ text, active, onClick }) => (
	<Wrapper $active={active} onClick={onClick}>
		{active ? <Icon src="/images/icons/tick.svg" /> : null}
		{text}
	</Wrapper>
);

const Wrapper = styled.div<{ $active: boolean }>`
	font-family: var(--font-sans);
	position: relative;
	font-size: 16px;
	line-height: 25px;
	color: var(--color-purple-50);
	margin: 7px 15px;
	padding-top: 8px;
	padding-bottom: 8px;
	padding-left: 25px;
	padding-right: 15px;
	cursor: pointer;

	${({ $active }) =>
		$active &&
		css`
			background-color: var(--color-purple);
			color: var(--color-white);
		`}

	--smooth-corners: 18.34, 4.2;
	mask-image: paint(smooth-corners);

	@media (max-width: 600px) {
		--smooth-corners: 27.34, 3.2;
		mask-image: paint(smooth-corners);
	}
`;

const Icon = styled.img`
	display: block;
	position: absolute;
	width: 16px;
	left: 5px;
	top: 50%;
	transform: translateY(-50%);
`;

export default FilterOption;
